export class SenderItem{
    idSender: number;
    nameSender: string;
    chosen: boolean;
    selected: boolean;
    constructor(item: SenderItem) {
        this.idSender = item.idSender;
        this.nameSender = item.nameSender;
        this.chosen = false;
        this.selected = false;
    }
}